var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLounges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 19,
    viewBox: "0 0 34 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64034 9.89473V8.30548C8.64034 6.54348 7.18928 5.09243 5.42729 5.09243H5.0818V2.7431C5.0818 1.63753 5.98007 0.739258 7.08564 0.739258H27.7114C28.8169 0.739258 29.7152 1.63753 29.7152 2.7431V5.09243H29.3697C27.6077 5.09243 26.1567 6.54348 26.1567 8.30548V9.89473H8.64034Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3697 6.81987H31.0281C32.41 6.81987 33.6538 7.85634 33.6883 9.23829C33.8265 10.793 32.5828 12.1404 31.0281 12.1404V18.0828C31.0281 18.4283 30.7517 18.7393 30.3716 18.7393H28.3332C28.0568 18.7393 27.815 18.5665 27.7114 18.2901L27.0895 16.5627C27.0204 16.2863 26.744 16.1135 26.4676 16.1135H8.1912C7.9148 16.1135 7.67296 16.2863 7.56932 16.5627L6.94743 18.2901C6.87834 18.5665 6.60194 18.7393 6.32555 18.7393H4.28716C3.94167 18.7393 3.63073 18.4629 3.63073 18.0828V12.1059C2.07603 12.1059 0.832268 10.793 0.970464 9.20374C1.10866 7.82179 2.35242 6.81987 3.73438 6.81987H5.39273C6.22191 6.81987 6.87834 7.4763 6.87834 8.30547V11.3112C6.87834 11.5185 7.05108 11.6567 7.22383 11.6567H27.5386C27.7459 11.6567 27.8841 11.484 27.8841 11.3112V8.30547C27.8841 7.4763 28.5405 6.81987 29.3697 6.81987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLounges);
export default __webpack_public_path__ + "static/media/lounges.08facf329a2fa2797d00c3a4d9c4826d.svg";
export { ForwardRef as ReactComponent };